import axios from 'axios'
import { endpoint } from '../config'

export function SET_GUILDS() {
    return (dispatch, state) => {
        return new Promise((resolve, reject) => {        
            const { token } = state().user.user
            axios({
                url: `${endpoint}/api/guilds`,
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${token}`
                }, 
            }).then(res => {
                dispatch({
                    type: 'SET_GUILDS',
                    payload: res.data.guilds
                })
                resolve()
            })
        })
    }
}

export function SET_GUILD_FEED(_id) {
    return (dispatch, state) => {
        return new Promise((resolve, reject) => {
            const { token } = state().user.user
            axios({
                url: `${endpoint}/api/wazzup?guild=${_id}`,
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${token}`
                }, 
            }).then(res => {
                dispatch({
                    type: 'REPLACE_ALL_GUILD_THREADS',
                    payload: res.data.data
                })
                resolve()
            })
        })
    }
}

export function LOAD_MORE_GUILD_FEED(_id, page=1) {
    return (dispatch, state) => {
        return new Promise((resolve, reject) => {
            const { token } = state().user.user
            axios({
                url: `${endpoint}/api/wazzup?guild=${_id}&page=${page}`,
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${token}`
                }, 
            }).then(res => {
                dispatch({
                    type: 'APPEND_GUILD_THREADS',
                    payload: res.data.data
                })
                resolve(res.data.data)
            }).catch(err => {
                reject(err)
            })
        })
        
    }
}

export function JOIN_GUILD(_id) {
    return (dispatch, state) => {
        return new Promise((resolve, reject) => {
            const { token } = state().user.user
            axios({
                url: `${endpoint}/api/guilds/${_id}/join`,
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${token}`
                }, 
            }).then(res => {
                resolve(res.data.guild)
            })
        })
    }
}

export function LEAVE_GUILD(_id) {
    return (dispatch, state) => {
        return new Promise((resolve, reject) => {
            const { token } = state().user.user
            axios({
                url: `${endpoint}/api/guilds/${_id}/leave`,
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${token}`
                }, 
            }).then(res => {
                dispatch({
                    type: 'UPDATE_GUILD',
                    payload: res.data.guild
                })
                resolve()
            })
        })
    }
}

export function SET_ACTIVE_GUILD(res) {
    return {
        type: 'SET_ACTIVE_GUILD',
        payload: res
    }
}

export function GET_GUILD_USERS(id) {
    return (dispatch, state) => {
        return new Promise((resolve, reject) => {
            const { token } = state().user.user
            axios({
                url: `${endpoint}/api/guilds/${id}/members`,
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${token}`
                }, 
            }).then(res => {
                dispatch({
                    type: 'GET_GUILD_USERS',
                    payload: res.data.data
                })
                resolve(res.data.data)
            }).catch(err => {
                reject(err)
            })
        })
        
    }
}